<!-- Copyright (c) 2019-2023 Cigent Technology Inc. All Rights Reserved. -->
<h2 id="GetPasswordDialog" mat-dialog-title appLifecycleTracker trackerName="get-password-dialog">{{password_required_title_text}}</h2>
<mat-dialog-content>
    <form id="registerForm" [formGroup]="passwordForm">
        <div>
            <p>{{password_required_text}}</p>
            <mat-form-field class="email-form-field" appearance="outline">
              <mat-label>{{ 'LI_PASSWORD' | translate }}</mat-label>
              <span style="display: flex;">
                  <input (keyup.enter)="onsubmit()" autocomplete="new-password" id="registerFormPassword"
                    type="password" formControlName="password"
                    matInput placeholder="{{password_placeholder_text}}" (input)="tooltip?.show()"
                    (capsLock)="onCapsLockChanged($event)" (focus)="passwordFocus()" (blur)="passwordBlur()"
                  />
                @if (capsOn) {
                  <mat-icon matIconSuffix class="mdi mdi-apple-keyboard-caps caps-on-icon" #tooltip="matTooltip"
                    matTooltip="{{'CAPS_LOCK_IS_ON' | translate}}" matTooltipPosition="right"></mat-icon>
                }
              </span>
            </mat-form-field>
        </div>
    </form>
</mat-dialog-content>
<mat-dialog-actions class="button-wrapper">
    <button id="passwordFormCancelButton" type="button" mat-raised-button (click)='cancel()'>{{cancel_text}}</button>
    <button id="passwordFormSubmitButton" type="button" mat-raised-button (click)='onsubmit()' color="primary">{{submit_text}}</button>
</mat-dialog-actions>
